export default __webpack_public_path__ + "static/after-2-86c30e5b1750ae245d552c6398ec0b4a.jpeg";